import React, { useState, useEffect, useContext } from 'react'
import { navigate } from 'gatsby'

import ButtonClose from '../../atoms/button-close/button-close'
import Button from '../../atoms/button/button'
import AppSlider from '../../atoms/appSlider/appSlider'
import { Context } from '../../../context/app-context'
import userSessionStorage from '../../../utils/userSessionStorage'

import { imagesWallpapers } from '../../organisms/wallpapersSection/wallpapers'

import './modalWallpapers.scss'
import { TROPICALIZED } from '../../../constants/activity-constants'
import Show from '../../../utils/show'

const SliderWallpapersSelector = ({ index = 0, onChange }) => {
  const settings = {
    initialSlide: index,
    afterChange: onChange,
  }

  return (
    <div className="f-modalWallpapers-slider">
      <p className="f-modalWallpapers-slider__text">
       {TROPICALIZED?'Hacé': 'Haz'} clic en las flechas para seleccionar otro wallpaper
      </p>
      <AppSlider settings={settings}>
        {imagesWallpapers.map((card, index) => {
          return (
            <img
              key={index}
              src={card.mobile}
              className="f-modalWallpapers-slider__item "
            />
          )
        })}
      </AppSlider>
    </div>
  )
}

const ModalWallpapers = () => {
  const urlParams = new URLSearchParams(window.location?.search)
  const [card, setCard] = useState(Number(urlParams?.get('id')))

  const { dispatch } = useContext(Context)

  const useIsLogged = () => {
    const session = new userSessionStorage()
    if (!session.getToken()) {
      return false
    }

    if (!session.getUserInfo()) {
      return false
    }

    return true
  }
  const isLogged = useIsLogged()

  const callModals = (type, props) => {
    dispatch({
      type: 'set-modal',
      modalActive: {
        type,
        props,
      },
    })
  }

  useEffect(() => {
    if (!isLogged) {
      callModals('login', {
        activity: 'wallpapers',
        handleSuccess: () => {
          dispatch({ type: 'clear-modal' })
          window.location.reload()
        },
        close: () => {
          dispatch({ type: 'clear-modal' })
          navigate('/')
        },
      })
    }
  }, [isLogged])

  const close = () => {
    dispatch({ type: 'clear-modal' })
    navigate('/#wallpapers')
  }

  const downloadImages = card => {
    callModals('redeem', {
      activity: 'wallpapers',
      onSuccess: () => {
        var link = document.createElement('a')
        link.download = `wallpaper-mobile-${card}.png`
        link.href = imagesWallpapers[card].mobile
        link.click()
        var link2 = document.createElement('a')
        link2.download = `wallpaper-desktop-${card}.png`
        link2.href = imagesWallpapers[card].desktop
        link2.click()
        callModals('finalcard', { wallpapers: true })
      },
      onClose: close,
    })
  }

  return (
    <div className="f-modalWallpapers-container">
      <div className="f-modalWallpapers-container__wrapper">
        <ButtonClose
          className="f-modalWallpapers-container__close "
          onClick={close}
        />
        <section className="f-modalWallpapers-container__left">
          <SliderWallpapersSelector
            index={card}
            onChange={_index => {
              setCard(_index)
            }}
          />
        </section>
        <section className="f-modalWallpapers-container__right">
          <h2>{TROPICALIZED?'Elegí':'Elige'} tu wallpaper</h2>
          <p>
            {TROPICALIZED?'Elegí':'Elige'} el wallpaper que más te guste para tu pc y para tu celular.
            <br />
            <br />
            <b>
              <Show valid={TROPICALIZED}>¡Recordá que se descargará el mismo diseño!</Show>
              <Show valid={TROPICALIZED===false}>¡Recuerda que se descargará el mismo diseño para ambos!</Show>
            </b>
          </p>
          <Button
            text="Continuar"
            onClick={() => downloadImages(card)}
            metric={{
              event: 'Interacciones_Diseño_Wallpaper',
              category: 'Plantilla',
              wallpaper_name: `wallpaper-${card}`,
            }}
          />
        </section>
      </div>
    </div>
  )
}

export default ModalWallpapers
